
export class ReservationsFilter {
    customer: string;
}
